import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiHome, FiBook, FiCheckCircle, FiHeart, FiArrowRight } = FiIcons;

function Navigation() {
  const location = useLocation();
  const isHome = location.pathname === '/';

  if (isHome) return null;

  return (
    <>
      <nav className="bg-white/80 backdrop-blur-sm border-b border-amber-100 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 py-3">
          <div className="flex items-center justify-between">
            <Link 
              to="/" 
              className="flex items-center space-x-2 text-amber-700 hover:text-amber-800 transition-colors"
            >
              <SafeIcon icon={FiHome} className="w-5 h-5" />
              <span style={{
        fontWeight: '500',
        fontSize: '22px',
        color: 'rgb(37, 88, 171)'
      }} className="font-serif text-lg">GospelWise Author Journey Starter</span>
            </Link>
            
            <div className="flex items-center space-x-6">
              <Link 
                to="/roadmap" 
                className="flex items-center space-x-1 text-emerald-700 hover:text-emerald-800 transition-colors"
              >
                <SafeIcon icon={FiBook} className="w-4 h-4" />
                <span className="text-sm">Roadmap</span>
              </Link>
              
              <Link 
                to="/checklist" 
                className="flex items-center space-x-1 text-emerald-700 hover:text-emerald-800 transition-colors"
              >
                <SafeIcon icon={FiCheckCircle} className="w-4 h-4" />
                <span className="text-sm">Checklist</span>
              </Link>
              
              <Link 
                to="/next-steps" 
                className="flex items-center space-x-1 bg-amber-600 text-white px-3 py-1 rounded-full hover:bg-amber-700 transition-colors text-sm"
              >
                <span>Next Steps</span>
                <SafeIcon icon={FiArrowRight} className="w-3 h-3" />
              </Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Footer */}
      <footer className="bg-white/80 backdrop-blur-sm border-t border-amber-100 mt-auto">
        <div className="max-w-4xl mx-auto px-4 py-6">
          <div className="text-center text-sm text-gray-600">
            <div className="flex items-center justify-center space-x-2">
              <a 
                href="https://www.gospelwiseauthor.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-emerald-700 hover:text-emerald-800 transition-colors font-medium"
              >
                Your Christian writing journey starts here
              </a>
              <span className="text-gray-400">•</span>
              <span>Made with <SafeIcon icon={FiHeart} className="w-4 h-4 text-rose-500 inline-block" /> by CROSS + PEN</span>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Navigation;